import React, { useState } from 'react';
import { X } from 'lucide-react';
interface SalesFormProps {
  isOpen: boolean;
  onClose: () => void;
  agentType?: string;
}
export function SalesForm({
  isOpen,
  onClose,
  agentType
}: SalesFormProps) {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    phone: '',
    message: ''
  });
  const handleChange = e => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = e => {
    e.preventDefault();
    // Handle form submission logic here
    console.log('Sales form submitted:', formData);
    // In a real implementation, this would send data to a backend service
    // that would forward the information to ramzad@rawfounders.com
    alert(`Thank you for your interest in ${agentType || 'our services'}! Your information has been sent to ramzad@rawfounders.com. Our sales team will contact you shortly.`);
    // Reset form
    setFormData({
      name: '',
      email: '',
      company: '',
      phone: '',
      message: ''
    });
    onClose();
  };
  if (!isOpen) return null;
  return <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4" data-id="element-345">
      <div className="bg-white rounded-xl w-full max-w-md relative" data-id="element-346">
        <button onClick={onClose} className="absolute top-4 right-4 text-gray-500 hover:text-gray-700" data-id="element-347">
          <X size={24} data-id="element-348" />
        </button>
        <div className="p-6" data-id="element-349">
          <h2 className="text-2xl font-bold mb-4" data-id="element-350">
            {agentType ? `Talk to Sales About ${agentType}` : 'Talk to Our Sales Team'}
          </h2>
          <p className="text-gray-600 mb-6" data-id="element-351">
            Fill out this form and our team will get back to you within 24
            hours.
          </p>
          <form onSubmit={handleSubmit} data-id="element-352">
            <div className="space-y-4" data-id="element-353">
              <div data-id="element-354">
                <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-355">
                  Full Name
                </label>
                <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:outline-none" required data-id="element-356" />
              </div>
              <div data-id="element-357">
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-358">
                  Business Email
                </label>
                <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:outline-none" required data-id="element-359" />
              </div>
              <div data-id="element-360">
                <label htmlFor="company" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-361">
                  Company Name
                </label>
                <input type="text" id="company" name="company" value={formData.company} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:outline-none" required data-id="element-362" />
              </div>
              <div data-id="element-363">
                <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-364">
                  Phone Number
                </label>
                <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:outline-none" data-id="element-365" />
              </div>
              <div data-id="element-366">
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-367">
                  How can we help you?
                </label>
                <textarea id="message" name="message" value={formData.message} onChange={handleChange} rows={3} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:outline-none" required data-id="element-368"></textarea>
              </div>
              <button type="submit" className="w-full bg-black text-white py-3 rounded-lg font-medium hover:bg-gray-800 transition-colors" data-id="element-369">
                Submit Request
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>;
}